import { format, subDays } from "date-fns";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import Axios from "../../api/Axios";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import MultipleCreditNotePDF from "./MultipleCreditNotePDF";

const MultipleCreditNotePrint = () => {
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState(null);
    const [partyname, setPartyname] = useState([]);
    const [creditdata, setCreditdata] = useState([]);
    const [printdata, setPrintdata] = useState([]);
    const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [loadingdt, setLoadingdt] = useState(false);
    const [showpopup, setShowpopup] = useState(false);
    const auth = storage.getLocal("user");
    useEffect(() => {
        const onPageLoad = async () => {
            try {
                setLoading(true);
                const cnFocurl = "MultipleCreditNotePrint/PopulateCustomerData?";
                const cnFocCustData = `${cnFocurl}CompId=${auth.CompId}`;
                let dataresponse = await Axios.get(cnFocCustData);
                if (dataresponse.data.Data != 0) {
                    const updatedData = dataresponse?.data?.Data.map(item => ({
                        ...item,
                        PARTY_NAME: `${item.PARTY_NAME} - ${item.PARTY_CODE}`
                    }));
                    setPartynamesugg(updatedData);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        onPageLoad();
    }, []);

    const getallcreditNote = async () => {
        if (onchangepartyname == null) {
            toast.warning("Please select one customer", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            setLoadingdt(true);
            const cnFocurl = "MultipleCreditNotePrint/GetAllCNRecords?";
            const cnFocCustData = `${cnFocurl}CompId=${auth.CompId}&Custid=${encodeURIComponent(onchangepartyname.MASK_PARTY_ID)}&FromDate=${fromDateRange}&ToDate=${toDateRange}`;
            let dataresponse = await Axios.get(cnFocCustData);
            if (dataresponse.data.Data != 0) {
                setCreditdata(dataresponse.data.Data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    useEffect(()=>{
        setCreditdata([]);
    },[onchangepartyname]);

    // console.log(onchangepartyname);

    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return employee.PARTY_NAME.toLowerCase().includes(
                        e.query.toLowerCase()
                    );
                });
            }

            setPartyname(_filteredemployee);
        }, 400);
    };
    const employeeTemplate = (employee) => {
        return <>{employee.PARTY_NAME}</>;
    };

    const downloadcndrdata = async()=>{
        // if(selectedInvoice.length>=25){
        //     toast.warning("selection can't be more than 25", {
        //         position: toast.POSITION.TOP_CENTER,
        //         pauseOnFocusLoss: false,
        //         closeButton: false,
        //         autoClose: 2000,
        //     });
        //     return;
        // }
        // console.log(selectedInvoice);
        let lstdata = selectedInvoice.map(item=>`${item.MASK_DRCR_HDR_ID}`).join(",");
        try {
            setLoadingdt(true);
            const cnFocurl = "MultipleCreditNotePrint/GetMultiCreditNoteData?";
            const cnFocCustData = `${cnFocurl}CompId=${auth.CompId}&PartyId=${encodeURIComponent(onchangepartyname.MASK_PARTY_ID)}&DRCRId=${lstdata}`;
            let dataresponse = await Axios.get(cnFocCustData);
            if (dataresponse.data.Data != 0) {
                setPrintdata(dataresponse.data.Data);
            }
            setShowpopup(true);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const stateProps = {showpopup, setShowpopup,
        printdata,setSelectedInvoice
    };



    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Multiple Credit Note Print</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12"></div>
                    </div>
                    <section className="sales-box">
                        <form>
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <label className="form-label">From Date</label>
                                    <Calendar
                                        onChange={(e) => {
                                            setFromDate(e.target.value);
                                        }}
                                        showIcon
                                        value={fromDate}
                                        min="2010-01-01"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <label className="form-label">To Date</label>
                                    <Calendar
                                        value={toDate}
                                        onChange={(e) => setToDate(e.value)}
                                        showIcon
                                        min="2010-01-01"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">Customer Name</label>
                                    <AutoComplete
                                        field="PARTY_NAME"
                                        value={onchangepartyname}
                                        suggestions={partyname}
                                        completeMethod={searchEmployee}
                                        onChange={(e) => {
                                            setOnchangepartyname(e?.value);
                                        }}
                                        dropdown={true}
                                        forceSelection
                                        itemTemplate={employeeTemplate}
                                        emptyMessage="No Customer found."
                                        showEmptyMessage
                                    />
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="text-end mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary me-3"
                                            onClick={getallcreditNote}
                                        >
                      Get Credit Notes
                                        </button>
                                        <button type="button" className="btn btn-primary" disabled={selectedInvoice.length==0} onClick={downloadcndrdata}>
                      Download <Fa.FaDownload className="ms-2" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                    {loadingdt ? (
                        <>
                            <Loader />
                        </>
                    ) : null}
                    <section className="mt-3">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3>Records</h3>
                            <div className="DataTable pb-4 pt-1">
                                <DataTable
                                    value={creditdata}
                                    paginator
                                    rows={10}
                                    selectionMode="multiple"
                                    selection={selectedInvoice}
                                    showSelectAll={true}
                                    rowsPerPageOptions={[10, 20]}
                                    scrollHeight="80vh"
                                    filterDisplay="row"
                                    selectionPageOnly={true}
                                    onSelectionChange={(e) => {
                                        setSelectedInvoice(e.value);
                                    }}
                                    scrollable
                                    stripedRows
                                    emptyMessage="No records found."
                                    tableStyle={{ minWidth: "100rem" }}
                                >
                                    <Column
                                        selectionMode="multiple"
                                        header="Select All"
                                        style={{ minwidth: "12rem" }}
                                    ></Column>
                                    <Column
                                        field="DRCR_NO"
                                        header="Document Number"
                                        style={{ minWidth: "12rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    />
                                    <Column
                                        field="DRCR_DATE"
                                        header="Document Date"
                                        style={{ minWidth: "8rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="PARTY_NAME"
                                        header="Customer Name"
                                        style={{ minWidth: "12rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="DIS_STATUS"
                                        header="Status"
                                        style={{ minWidth: "6rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="SCHM_DESC"
                                        header="Scheme Description"
                                        style={{ minWidth: "6rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="GENERATED_BY"
                                        header="Created By"
                                        style={{ minWidth: "10rem" }}
                                        filterMatchMode="contains"
                                        filter
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                    <Column
                                        field="MASK_TOT_DRCR_AMT"
                                        header="Total Amount (₹)"
                                        style={{ minWidth: "6rem" }}
                                        className="text-end Right_Column"
                                    ></Column>
                                    <Column
                                        field="MASK_TOT_ADJ_AMT"
                                        header="Total Adjusted Amount (₹)"
                                        style={{ minWidth: "8rem" }}
                                        className="text-end Right_Column"
                                    ></Column>
                                </DataTable>
                            </div>
                        </div>
                    </section>
                </div>
                {showpopup&& <MultipleCreditNotePDF stateProps={stateProps}/>}
            </>
        );
    }
};

export default MultipleCreditNotePrint;
